import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { Sms } from '../../model/sms';
import { SmsService } from '../../service/data/sms.service';
import { dateTimeString } from '../../../core/helper/date-time';

@Component({
    selector: 'app-sms-form',
    templateUrl: './sms-form.component.html',
    styleUrls: ['./sms-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmsFormComponent extends FormComponentBase<Sms> {
  constructor(
    commandDispatcher: CommandDispatcher,
    private _smsService: SmsService,
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, _smsService, messageService, navigation, commandDispatcher, handlerResolver);
  }

  protected createModel(): Sms {
    return new Sms();
  }

  public isSent: boolean;

  protected getFormGroup(): FormGroup {
    this.isSent = this.dataContext.deliveredDateTime !== undefined && this.dataContext.deliveredDateTime !== null;

    return this._fb.group({
      statusCaption: this._fc.createReadonly('COMMON.STATUS', this.dataContext.statusCaption),
      createdDateTime: this._fc.createReadonly('COMMON.CREATED_DATE', dateTimeString(this.dataContext.createdDateTime)),
      sentDateTime: this._fc.createReadonly('COMMON.SENT', dateTimeString(this.dataContext.deliveredDateTime)),
      receiverName: this._fc.createReadonly('COMMON.RECEIVER', this.dataContext.receiverName),
      phone: this._fc.createReadonly('COMMON.PHONE_NUMBER', this.dataContext.phone),
      message: this._fc.createReadonly('MAIL_FORM.BODY_SMS_LABEL', this.dataContext.message),
    });
  }
}
